import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { SessionsState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: SessionsState = getDefaultState();

const namespaced: boolean = true;

export const sessions: Module<SessionsState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
